import { isAPIError, post } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { searchUrl } from '../ActivityHistory/constants'
import { ActivityHistorySearchInput, initialState } from '../state'
import { fetchActivityHistoryActionCreator } from '../state/actions/updateActivityHistory'

export async function fetchActivityHistory(search: ActivityHistorySearchInput) {
  const response = await post(searchUrl, search)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to load Activity History')
    }
    return fetchActivityHistoryActionCreator(initialState.history)
  }

  return fetchActivityHistoryActionCreator(result)
}
